import { horizontalSigningQueryKeys } from "./queryKeys"
import { useHorizontalSigningQuery } from "./useHorizontalSigningQueries"

export function useHorizontalSigningCampaignElements(campaignId, config = {}) {
    const url = "horizontal_signs/"

    const queryParameters = {
        campaign: campaignId,
    }

    const queryKey = horizontalSigningQueryKeys["layer"](queryParameters)

    return useHorizontalSigningQuery(
        url,
        queryKey,
        queryParameters,
        config,
    )
}
